import Client from "@/http/client";
import {
  SupportUserFilterParams,
  SupportUserListDto,
  SupportAuditListDto,
} from "@/http/dto/supportUser";

export class SupportUsers {
  static async getUsers(params: SupportUserFilterParams) {
    return await Client.get<SupportUserListDto>("/v2/supporter/users", params);
  }

  static async getPasswordResets(params: {
    page: number;
    take: number;
    targetUserObjectId?: string;
  }) {
    return await Client.get<SupportAuditListDto>(
      "/v2/supporter/users/password-resets",
      params,
    );
  }

  static async resetPassword(userObjectId: string, reset: { password: string; reason: string }) {
    return await Client.post(
      `/v2/supporter/users/${userObjectId}/password-reset`,
      reset,
    );
  }
}
